// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__p8tUd","content":"style_content__HmcrB","bg_main":"style_bg_main__cOs+q","bg_top":"style_bg_top__9sMcO"};